<div id="content_section">
  <div id="content_main" style="margin-right: 320px">
    <div id="content_sidebar" class="container-shadow content-sidebar" style="width: 300px; position: fixed; right: 20px">
      <a type="button" class="btn btn-primary btn-sm" style="width: 100%" [routerLink]="'/matter_types/new'">
        <span class="glyphicon glyphicon-plus-sign"></span>
        &nbsp;New Matter Type
      </a>
      <hr style="margin-top: 5px; margin-bottom: 5px" />
      <form (submit)="submitCloneForm(currentCloneToForm.form.valid, 'clone_to')" #currentCloneToForm="ngForm" novalidate>
        <legend>Clone to</legend>
        <div class="form-group">
          <span class="help-block">
            <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;Select matter types to clone using the checkboxes in the table
            <br />
            <span class="label label-default">{{ selectedMatterTypeCount() }}</span>
          </span>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!cloneToFormSubmitted || this.cloneToSelection.matter_type_ids.length > 0">Atleast one matter type must be selected for cloning</div>
        </div>
        <div class="form-group">
          <label>Intranet</label>
          <select class="form-control" [(ngModel)]="cloneToSelection.intranet_id" name="clone_to_intranet_id" required #clone_to_intranet_id="ngModel">
            <option *ngFor="let intranet of cloneOptions.intranets" [value]="intranet.value">{{ intranet.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!cloneFieldShowErrorMessage(clone_to_intranet_id, 'clone_to')">Intranet should be selected</div>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="cloneToSelection.include_client_intake_fields" name="include_client_intake_fields" />
            Include client intake fields
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="cloneToSelection.include_accounting_dependencies" name="include_accounting_dependencies" />
            Include accounting dependencies
          </label>
        </div>
        <div class="form-group text-center">
          <button type="submit" class="btn btn-primary" [disabled]="cloneToFormSubmitting">Go</button>
        </div>
      </form>
      <br />
      <hr style="margin-top: 5px; margin-bottom: 5px" />
      <form (submit)="submitCloneForm(currentCloneFromForm.form.valid, 'clone_from')" #currentCloneFromForm="ngForm" novalidate>
        <legend>Clone From</legend>
        <div class="form-group">
          <label>Intranet</label>
          <select class="form-control" [(ngModel)]="cloneFromSelection.intranet_id" name="clone_from_intranet_id" required #clone_from_intranet_id="ngModel" (change)="onCloneFromIntranetSelect()">
            <option *ngFor="let intranet of cloneOptions.intranets" [value]="intranet.value">{{ intranet.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!cloneFieldShowErrorMessage(clone_from_intranet_id)">Intranet should be selected</div>
        </div>
        <div class="form-group">
          <label>Matter Type</label>
          <select class="form-control" [(ngModel)]="cloneFromSelection.matter_type_id" name="clone_from_matter_type_id" required #clone_from_matter_type_id="ngModel">
            <option *ngFor="let matter_type of cloneFromMatterTypes" [value]="matter_type.id">{{ matter_type.name }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!cloneFieldShowErrorMessage(clone_from_matter_type_id)">Matter Type should be selected</div>
          <span class="help-block" [hidden]="cloneFieldShowErrorMessage(clone_from_matter_type_id)">
            {{ intranetMatterTypeCount() }}
          </span>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="cloneFromSelection.include_client_intake_fields" name="include_client_intake_fields" />
            Include client intake fields
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="cloneFromSelection.include_accounting_dependencies" name="include_accounting_dependencies" />
            Include accounting dependencies
          </label>
        </div>
        <div class="form-group text-center">
          <button type="submit" class="btn btn-primary" [disabled]="cloneFromFormSubmitting">Go</button>
        </div>
      </form>
      <hr style="margin-top: 5px; margin-bottom: 5px" />
    </div>
    <div class="content_inner" style="padding: 0px 20px 10px 20px">
      <div class="container-fluid container-shadow py-3 px-3">
        <div class="page-header">
          <h2>Matter Types</h2>
        </div>
        <table class="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Group</th>
              <th>Flat Fee</th>
              <th>Hourly</th>
              <th>No Chg</th>
              <th>Percent</th>
              <th>Invoice</th>
              <th>Consult Fee</th>
              <th>Retainer</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let matterType of matterTypes">
              <td>
                <ng-template #popTemplate>
                  <table>
                    <tr *ngFor="let i of objectKeys(matterType)">
                      <td>{{ i[0].toUpperCase() }}{{ i.slice(1) }}</td>
                      <td>{{ matterType[i] }}</td>
                    </tr>
                  </table>
                </ng-template>
                <a [routerLink]="'/matter_types/' + matterType.id + '/edit'" class="pop-link" [popover]="popTemplate" [triggers]="'hover'" [placement]="'right'">{{ matterType.name }}</a>
                <a class="pop invisible" data-toggle="tooltip" href="#" [attr.data-content]="matterTypePopUp(matterType)"></a>
                <br />
                <span *ngIf="matterType.regarding" class="pull-right float-right">Regarding:</span>
                <br *ngIf="matterType.regarding && matterType.we_will_do" />
                <span *ngIf="matterType.we_will_do" class="pull-right float-right">Our Duties:</span>
              </td>
              <td>
                {{ matterType.graph_label }}
                <br />
                <span *ngIf="matterType.regarding">{{ matterType.regarding }}</span>
                <br *ngIf="matterType.regarding && matterType.we_will_do" />
                <span *ngIf="matterType.we_will_do">{{ matterType.we_will_do }}</span>
              </td>
              <td>{{ matterType.is_flat_fee }}</td>
              <td>{{ matterType.is_hourly }}</td>
              <td>{{ matterType.is_no_charge }}</td>
              <td>{{ matterType.is_percentage }}</td>
              <td>{{ matterType.invoice_by_default }}</td>
              <td>{{ matterType.consult_fee != null ? (matterType.consult_fee | currency:'USD':'symbol':'1.2-2') : '' }}</td>
              <td>{{ matterType.retainer != null ? (matterType.retainer | currency:'USD':'symbol':'1.2-2') : '' }}</td>
              <td>
                <a (click)="deleteMatterType(matterType.id)" href="javascript: void(0)" class="text-danger">delete</a>
              </td>
              <td>
                <input type="checkbox" [(ngModel)]="matterType.checked_for_edit" (change)="onMatterTypeSelect(matterType.id)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div style="height: 300px" class="my-5"></div>
